module.exports = __webpack_public_path__ + "img/bg4.7ca8e000.png";